// extracted by mini-css-extract-plugin
export var acitonButtons = "_h0-0";
export var additionalIcon = "_h0-f";
export var block = "_h0-1";
export var blockContent = "_h0-7";
export var blockDescription = "_h0-8";
export var blockIcon = "_h0-9";
export var blockTitle = "_h0-6";
export var border = "_h0-a";
export var center = "_h0-l";
export var edge = "_h0-b";
export var edgeLabel = "_h0-c";
export var edgePath = "_h0-d";
export var error = "_h0-e";
export var flowchart = "_h0-g";
export var flowchartContent = "_h0-h";
export var highlighted = "_h0-3";
export var hover = "_h0-4";
export var icon = "_h0-i";
export var left = "_h0-m";
export var navButton = "_h0-j";
export var navButtons = "_h0-k";
export var right = "_h0-n";
export var selected = "_h0-2";
export var small = "_h0-5";